/**
 * Compact stat bars for arcade-style panels outside the timed arena shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import {
  ArcadeStatPill,
  type ArcadeStatPillProps,
} from "./ArcadeControls.js";

export interface ArcadeStatsBarProps {
  readonly stats: readonly ArcadeStatPillProps[];
  readonly background?: string;
  readonly borderColor: string;
  readonly trailing?: React.ReactNode;
}

export function ArcadeStatsBar({
  stats,
  background = "rgba(0,0,0,0.24)",
  borderColor,
  trailing,
}: ArcadeStatsBarProps): React.JSX.Element {
  return (
    <div
      className="flex flex-wrap items-center gap-3 border-b px-4 py-3"
      style={{ background, borderColor }}
    >
      {stats.map((stat) => (
        <ArcadeStatPill
          key={stat.label}
          label={stat.label}
          value={stat.value}
          color={stat.color}
          title={stat.title}
        />
      ))}
      {trailing ? <div className="ml-auto">{trailing}</div> : null}
    </div>
  );
}
